import { ref } from "vue";
import { defineStore } from "pinia";

export const useDsApiStore = defineStore("ds-api", () => {
  /**
   * usage of states in component to keep reactivity
   * const { maintenance, online } = storeToRefs(useDsApiStore())
   * then you can use online.value to get or mutate the data
   * If not using storeToRefs, reactivity might be lost so a watcher will be needed
   */
  const maintenance = ref<boolean>(false);
  const online = ref<boolean>(true);

  /**
   * usage of actions in component:
   * const apiStore = useDsApiStore();
   * const { setMaintenanceOn, setOnline, ...  } = apiStore
   */
  const setMaintenanceOn = (): void => {
    maintenance.value = true;
  };
  const setMaintenanceOff = (): void => {
    maintenance.value = false;
  };
  const setOnline = (): void => {
    online.value = true;
  };
  const setOffline = (): void => {
    online.value = false;
  };

  return {
    maintenance,
    online,
    setMaintenanceOn,
    setMaintenanceOff,
    setOnline,
    setOffline,
  };
});
